import { axiosInstance } from './base'

export function fetchBookmarks () {
  return axiosInstance.get('bookmarks/')
}

export function addBookmark (data) {
  return axiosInstance.post('bookmarks/', data)
}

export function deleteBookmark (id) {
  return axiosInstance.delete(`bookmarks/${id}/delete`)
}
